import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("AppointmentScreenWrapper", {
    attrs: { "data-qa": "appointment_error" },
    scopedSlots: _vm._u(
      [
        {
          key: "main",
          fn: function () {
            return [
              _c(VImg, {
                staticClass: "mx-auto",
                attrs: {
                  contain: "",
                  width: "130",
                  height: "130",
                  src: _vm.urls.iconCancel,
                  alt: _vm.errorData.title,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "text--text text-h6 mt-4 text-center",
                  style: { maxWidth: _vm.errorData.titleMaxWidth },
                  attrs: { "data-qa": "appointment_error_title" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(_vm.errorData.title, {
                          ..._vm.options,
                          daily_limit: _vm.dailyLimit,
                        })
                      ) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "text-body-2 text-secondary--text text-center mt-2 mx-auto",
                  style: { width: _vm.isMobile ? "60%" : "" },
                  attrs: { "data-qa": "appointment_error_subtitle" },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t(_vm.errorData.subtitle, _vm.options)) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              !_vm.isMobile && _vm.errorData.showPhone
                ? _c(
                    "div",
                    { staticClass: "text-h4 text--text text-center mt-4" },
                    [_vm._v("\n      " + _vm._s(_vm.lpuData.phone) + "\n    ")]
                  )
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        (_vm.isMobile && _vm.errorData.showPhone) ||
        _vm.currentActions.buttonSecond
          ? {
              key: "actions",
              fn: function ({ buttonProps }) {
                return [
                  _vm.isMobile && _vm.errorData.showPhone
                    ? _c(
                        VBtn,
                        _vm._b(
                          {
                            attrs: {
                              "data-qa": "appointment_error_phone_btn",
                              href: `tel:${_vm.formattedLpuPhone}`,
                            },
                          },
                          "v-btn",
                          buttonProps,
                          false
                        ),
                        [
                          _vm._v(
                            "\n      " + _vm._s(_vm.lpuData.phone) + "\n    "
                          ),
                        ]
                      )
                    : [
                        _vm.currentActions.buttonSecond
                          ? _c(
                              VBtn,
                              _vm._g(
                                _vm._b(
                                  {
                                    class: {
                                      "mb-2": _vm.currentActions.buttonFirst,
                                    },
                                    attrs: {
                                      "data-qa": "appointment_error_back_btn",
                                    },
                                    on: { click: _vm.handleClickButtonSecond },
                                  },
                                  "v-btn",
                                  buttonProps,
                                  false
                                ),
                                _vm.currentActions.buttonSecond.on
                              ),
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.currentActions.buttonSecond.text,
                                        _vm.options
                                      )
                                    ) +
                                    "\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentActions.buttonFirst
                          ? _c(
                              VBtn,
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      text: "",
                                      "data-qa": "appointment_error_first_btn",
                                    },
                                  },
                                  "v-btn",
                                  buttonProps,
                                  false
                                ),
                                _vm.currentActions.buttonFirst.on
                              ),
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.currentActions.buttonFirst.text,
                                        _vm.options
                                      )
                                    ) +
                                    "\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                ]
              },
            }
          : null,
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }